import * as React from 'react';
import { View, Image, Text, StatusBar, ActivityIndicator, StyleSheet, I18nManager, Button } from 'react-native';
import Colors from '../constants/Colors';
import { setAccessToken } from '../store/action/userLogin';
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useDispatch } from 'react-redux';
import NetInfo from "@react-native-community/netinfo";
import { MaterialCommunityIcons } from '@expo/vector-icons';
import Btn from '../components/btn';





function Splash(props) {

  

  const [animating, setAnimating] = React.useState(true);
  const dispatch = useDispatch();
const [network, setNetwork] = React.useState('')
  const [loading, setLoading] = React.useState(false);


  const chivane = async () => {

    try {
      const access_token = await AsyncStorage.getItem("access_token");

      if (access_token) {
        await dispatch(setAccessToken(access_token));
        props.navigation.replace('home')
      } else {
        setAnimating(false);
        props.navigation.replace('login')
      }

    } catch (error) {
      console.log(e)
    }

  }



  function unsubscribe() {
    NetInfo.fetch().then(state => {
      setNetwork(state)
      setTimeout(function () {
        if (state.isConnected) {
          chivane()
          // any thing you want to load before navigate home screen
        } else {
          setLoading(false)
        }
      }, 3000);
    })
  };









  React.useEffect(() => {
    unsubscribe()
  }, []);



  // React.useEffect(() => {
  //   const ac = new AbortController();
  //       setTimeout(() => {
  //  chivane()
  //   }, 3000);
  //   return () => ac.abort();
  // }, []);






  return !network?.isConnected || loading ? (



    

      
        <View style={styles.viewContainer}>

          <StatusBar backgroundColor={Colors.background} />

          <View style={{ opacity: 0.9, zIndex: 2, flexDirection: "row", position: "absolute", width: "100%", height: "100%", backgroundColor: Colors.secondText3, alignItems: "center", justifyContent: "center" }}>
            <MaterialCommunityIcons name={"connection"} size={30} color={Colors.primarydark} />

            <Text style={{ fontFamily: "MontserratBold", fontSize: 30, color: Colors.primarydark, marginLeft: 10 }}>خطا در اتصال اینترنت</Text>

            <Btn
              label="تلاش مجدد"
              style={{ width: "49%", marginTop: 10, position: "absolute", bottom: "20%" }}
              textStyle={{ bottom: 10, color: Colors.background }}
              touchableStyle={{ backgroundColor: Colors.primarydark, elevation: 0 }}
              colorspin={Colors.background}
              sizespin={25}
              loading={loading}
              onPress={() => {
                setLoading(true)
                unsubscribe()
              }}

            />


          </View>
        </View>





   ) :(
        <View style={styles.viewContainer}>
          <StatusBar backgroundColor={Colors.background} />
          <Image source={require("../../assets/logo250.png")} alt="image" style={styles.image} />
          <Text style={styles.text}>
              پلنرس
          </Text >
          {/* <Text style={styles.text1}>
            فارس
          </Text > */}
          <ActivityIndicator color={Colors.primary} size={40} animating={animating} />

        </View>
   )



  

  
}

const styles = StyleSheet.create({
  viewContainer: {
    width: "100%",
    height: "100%",
    backgroundColor: Colors.background,
    alignItems: 'center',
    justifyContent: "center"
  },
  text: {
    color: Colors.primary,
    fontSize: 40,
    fontFamily: "MontserratBold",
    bottom: "6%"

  },
  text1: {
    color: Colors.primary,
    fontSize: 70,
    fontFamily: "MontserratBold",
    bottom: "10%"
  },
  image: {
    width: 292,
    height: 280,
    marginBottom:50

  }

})
export default Splash
